// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__31EaA","inputDescription":"styles_inputDescription__2s6mI"};